export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/capital_d_design-bd70dc7d2be32ff57bd5d4b179bab28d.png";